<script lang="ts">
export interface LinkBaseProps {
  as?: string;
  type?: string;
  disabled?: boolean;
  to?: string;
  href?: string;
  navigate?: (e: MouseEvent) => void;
  target?: '_blank' | '_parent' | '_self' | '_top' | (string & {}) | null;
  rel?: 'noopener' | 'noreferrer' | 'nofollow' | 'sponsored' | 'ugc' | (string & {}) | null;
  active?: boolean;
  isExternal?: boolean;
}
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { Primitive } from 'reka-ui';

const props = withDefaults(defineProps<LinkBaseProps>(), {
  as: 'button',
  type: 'button'
});

const linkUrl = computed(() => props.to || props.href);

function onClickWrapper(e: MouseEvent) {
  if (props.disabled) {
    e.stopPropagation();
    e.preventDefault();
    return;
  }

  if (linkUrl.value && props.navigate && !props.isExternal) {
    props.navigate(e);
  }
}
</script>

<template>
  <primitive
    :as="linkUrl ? 'a' : props.as"
    :href="linkUrl && !props.disabled ? linkUrl : undefined"
    :type="!linkUrl ? props.type : undefined"
    :disabled="!linkUrl ? props.disabled : undefined"
    :aria-disabled="linkUrl && props.disabled ? 'true' : undefined"
    :role="linkUrl && props.disabled ? 'link' : undefined"
    :tabindex="linkUrl && props.disabled ? -1 : undefined"
    :rel="props.rel"
    :target="props.target"
    @click="onClickWrapper"
  >
    <slot />
  </primitive>
</template>
